import React, { Component } from 'react';
import Bodycontent from './bodycontent';
import Bodycontenttv from './bodycontenttv';
import Bodycontenttvjw from './bodycontenttvjw';
import Bodycontentyoutubefree from './bodycontentyoutubefree';
import Logs from './logs';
import Users from './users';
import Chat from './../chat/chat';
import firebase from "./../firebase";
import PageTODO from './todo/PageTODO';
import PageWinampp from './winamp/Winampp';
import { getDatabase,onValue, ref, orderByChild, equalTo, get, set, child, update,query,push } from "firebase/database";

export default class Bodyhead extends Component {
    constructor(props) {
        super(props);
        this.toogglesidebar= this.toogglesidebar.bind(this);
        this.state = {
            active: false,
            pagetv: false,
            pagechat: false,
            pagehome: true,
            pagetvjw: false,
            pageyoutubefree: false,
            pagelogs: false,
            pageusers: false,
            pagetodo:false,
            pagewinampp:false,
            user: [],
            role: '',
            adminrole: '"admin"',
            adminrolec: '"adminc"',
            adminrolef: '"adminf"',
        };
    }

    componentDidMount(){
        //console.log(localStorage.getItem('authlogin'));
        if(localStorage.getItem('authlogin')==='false'){
            window.location.href = "#/login";
        }
        
        const db = getDatabase();
        const query_tmp = query(ref(db,"/users"), orderByChild('email'),equalTo(localStorage.getItem('user_id')));
        onValue(query_tmp, (snapshot) => {
            var userg = []
            snapshot.forEach(child => {
            var data = child.val()
            userg.push({
            id: data.key, 
            email: data.email,
            name: data.name,
            nickname: data.nickname,
            phone: data.phone,
            role: data.role,
            time: data.time
            })
            this.setState({ user: userg })
            this.setState({ role: JSON.stringify(this.state.user[0].role) })
        })
            
        })
        setTimeout(function(){ 
        //alert(this.state.role)  
        this.forceUpdate()
        //this.setState({ state: this.state });
        //console.log(this.state.role);
        //console.log(this.state.adminrole);
        }.bind(this), 2500); 
        
    }

    toogglesidebar(){
        const currentState = this.state.active;
        //alert(currentState);
        //this.forceUpdate()
        this.setState({ active: !currentState });
    };

    pagetv(){
        this.setState({ pagehome: false });
        this.setState({ pagechat: false });
        this.setState({ pagetv: true });
        this.setState({ pagetvjw: false });
        this.setState({ pageyoutubefree: false });
        //alert(this.state.pagetv);
        this.setState({ pagelogs: false });
        this.setState({ pageusers: false });
        this.setState({ pagetodo: false });
        this.setState({ pagewinampp: false });
    };

    pagechat(){
        this.setState({ pagehome: false });
        this.setState({ pagechat: true });
        this.setState({ pagetv: false });
        //alert(this.state.pagechat);
        this.setState({ pagetvjw: false });
        this.setState({ pageyoutubefree: false });
        this.setState({ pagelogs: false });
        this.setState({ pageusers: false });
        this.setState({ pagetodo: false });
        this.setState({ pagewinampp: false });
    };

    pagelogs(){
        this.setState({ pagehome: false });
        this.setState({ pagechat: false });
        this.setState({ pagetv: false });
        //alert(this.state.pagechat);
        this.setState({ pagetvjw: false });
        this.setState({ pageyoutubefree: false });
        this.setState({ pagelogs: true });
        this.setState({ pageusers: false });
        this.setState({ pagetodo: false });
        this.setState({ pagewinampp: false });
    };

    pageusers(){
        this.setState({ pagehome: false });
        this.setState({ pagechat: false });
        this.setState({ pagetv: false });
        //alert(this.state.pagechat);
        this.setState({ pagetvjw: false });
        this.setState({ pageyoutubefree: false });
        this.setState({ pagelogs: false });
        this.setState({ pageusers: true });
        this.setState({ pagetodo: false });
        this.setState({ pagewinampp: false });
    };

    homepage(){
        this.setState({ pagehome: true });
        this.setState({ pagechat: false });
        this.setState({ pagetv: false });
        //alert(this.state.pagehome);
        this.setState({ pagetvjw: false });
        this.setState({ pageyoutubefree: false });
        this.setState({ pagelogs: false });
        this.setState({ pageusers: false });
        this.setState({ pagetodo: false });
        this.setState({ pagewinampp: false });
    };

    pagetvjwpage(){
        this.setState({ pagehome: false });
        this.setState({ pagechat: false });
        this.setState({ pagetv: false });
        //alert(this.state.pagehome);
        this.setState({ pagetvjw: true });
        this.setState({ pageyoutubefree: false });
        this.setState({ pagelogs: false });
        this.setState({ pageusers: false });
        this.setState({ pagetodo: false });
        this.setState({ pagewinampp: false });
    };

    pageyoutubefree(){
        this.setState({ pagehome: false });
        this.setState({ pagechat: false });
        this.setState({ pagetv: false });
        //alert(this.state.pagehome);
        this.setState({ pagetvjw: false });
        this.setState({ pageyoutubefree: true });
        this.setState({ pagelogs: false });
        this.setState({ pageusers: false });
        this.setState({ pagetodo: false });
        this.setState({ pagewinampp: false });
    };

    pagetodo(){
        this.setState({ pagehome: false });
        this.setState({ pagechat: false });
        this.setState({ pagetv: false });
        //alert(this.state.pagehome);
        this.setState({ pagetvjw: false });
        this.setState({ pageyoutubefree: false });
        this.setState({ pagelogs: false });
        this.setState({ pageusers: false });
        this.setState({ pagetodo: true });
        this.setState({ pagewinampp: false });
    };

    pagewinampp(){
        this.setState({ pagehome: false });
        this.setState({ pagechat: false });
        this.setState({ pagetv: false });
        //alert(this.state.pagehome);
        this.setState({ pagetvjw: false });
        this.setState({ pageyoutubefree: false });
        this.setState({ pagelogs: false });
        this.setState({ pageusers: false });
        this.setState({ pagetodo: false });
        this.setState({ pagewinampp: true });
    };

    render(){
        const divStylesssp={
            position:'relative',
            marginBottom: '150px',
          };
        if(localStorage.getItem('authlogin')==='true'){
        return (
            <body className="main-body">
        <div className="wrapper">
                <nav id="sidebar" className={this.state.active ? 'active': null} >
                    <div className="sidebar-header">
                        <h3>Bootstrap Sidebar</h3>
                        <strong>BS</strong>
                    </div>
            
                    <ul className="list-unstyled components">
                        <li className="active">
                            <a href="#/dashboard" onClick={() =>this.homepage()}>
                                <i className="fa fa-home"></i>
                                Home
                            </a>
                        </li>
                        <li className="active">
                            <a href="#/dashboard" onClick={() =>this.pagetv()}>
                                <i className="fa fa-television"></i>
                                TV Page
                            </a>
                        </li>
                        {this.state.role===this.state.adminrole && (<li className="active">
                            <a href="#/dashboard" onClick={() =>this.pagetvjwpage()}>
                                <i className="fa fa-television"></i>
                                TV JW Page
                            </a>
                        </li>)}
                        {this.state.role===this.state.adminrolec && (<li className="active">
                            <a href="#/dashboard" onClick={() =>this.pagetvjwpage()}>
                                <i className="fa fa-television"></i>
                                TV JW Page
                            </a>
                        </li>)}
                        {this.state.role===this.state.adminrolef && (<li className="active">
                            <a href="#/dashboard" onClick={() =>this.pagetvjwpage()}>
                                <i className="fa fa-television"></i>
                                TV JW Page
                            </a>
                        </li>)}
                        {this.state.role===this.state.adminrole && (<li className="active">
                            <a href="#/dashboard" onClick={() =>this.pageyoutubefree()}>
                                <i className="fa fa-television"></i>
                                Youtube Free Page
                            </a>
                        </li>)}
                        {this.state.role===this.state.adminrolec && (<li className="active">
                            <a href="#/dashboard" onClick={() =>this.pageyoutubefree()}>
                                <i className="fa fa-television"></i>
                                Youtube Free Page
                            </a>
                        </li>)}
                        {this.state.role===this.state.adminrolef && (<li className="active">
                            <a href="#/dashboard" onClick={() =>this.pageyoutubefree()}>
                                <i className="fa fa-television"></i>
                                Youtube Free Page
                            </a>
                        </li>)}
                        {this.state.role===this.state.adminrolef && (<li className="active">
                            <a href="#/dashboard" onClick={() =>this.pagetodo()}>
                                <i className="fa fa-television"></i>
                                Page TODO
                            </a>
                        </li>)}
                        <li className="active">
                            <a href="#/dashboard" onClick={() =>this.pagetodo()}>
                                <i className="fa fa-television"></i>
                                Page TODO
                            </a>
                        </li>
                        {this.state.role===this.state.adminrolef && (<li className="active">
                            <a href="#/dashboard" onClick={() =>this.pagewinampp()}>
                                <i className="fa fa-television"></i>
                                Page Winampp
                            </a>
                        </li>)}
                        <li className="active">
                            <a href="#/dashboard" onClick={() =>this.pagewinampp()}>
                                <i className="fa fa-television"></i>
                                Page Winampp
                            </a>
                        </li>
                        <li className="active">
                            <a href="#/dashboard" onClick={() =>this.pagechat()}>
                                <i className="fa fa-comments-o"></i>
                                Chat Page
                            </a>
                        </li>
                        {this.state.role===this.state.adminrole && (<li>
                            <a href="">
                                <i className="fa fa-briefcase"></i>
                                About
                            </a>
                            <a href="#pageSubmenu" data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                                <i className="fa fa-copy"></i>
                                Pages
                            </a>
                            <ul className="collapse list-unstyled" id="pageSubmenu">
                                <li>
                                    <a href="#">Page 1</a>
                                </li>
                                <li>
                                    <a href="#">Page 2</a>
                                </li>
                                <li>
                                    <a href="#">Page 3</a>
                                </li>
                            </ul>
                        </li>)}
                        {this.state.role===this.state.adminrole && (<li>
                            <a href="#/dashboard" onClick={() =>this.pagelogs()}>
                                <i className="fa fa-history"></i>
                                Logs
                            </a>
                        </li>)}
                        {this.state.role===this.state.adminrole && (<li>
                            <a href="#/dashboard" onClick={() =>this.pageusers()}>
                                <i className="fa fa-user"></i>
                                Users
                            </a>
                        </li>)}
                    </ul>
            
                </nav>
            
                <div id="content">
            
                        <nav className="navbar navbar-expand-lg navbar-light bg-light">
                                <div className="container-fluid">
                
                                    <button type="button" id="sidebarCollapse" className="btn btn-info" onClick={() =>this.toogglesidebar()}>
                                        <i className="fa fa-align-left"></i>
                                        <span>Toggle Sidebar</span>
                                    </button>
                                    <button className="btn btn-dark d-inline-block d-lg-none ml-auto" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                        <i className="fa fa-align-justify"></i>
                                    </button>
                
                                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                    {this.state.role===this.state.adminrole && (<ul className="nav navbar-nav ml-auto">
                                            <li className="nav-item active">
                                                <a className="nav-link" href="#">Page</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" href="#">Page</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" href="#">Page</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" href="#">Page</a>
                                            </li>
                                        </ul>)}
                                        <ul className="nav navbar-nav ml-auto">
                                        <div className="dropdown">
                                        <button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown">
                                        <i className="fa fa-user"></i>
                                        </button>
                                        <div className="dropdown-menu dropdown-menu-right text-right">
                                        {this.state.role===this.state.adminrole && (<a className="dropdown-item" href="#">Link 1</a>)}
                                        {this.state.role===this.state.adminrole && (<a className="dropdown-item" href="#">Link 2</a>)}
                                            <a className="dropdown-item" href="#/logout">Logout</a>
                                        </div>
                                        </div>
                                        </ul>
                                    </div>
                                </div>
                            </nav>

                            <div className="wrapper">
                                <div className="container">
                                    {this.state.pagehome===true && (<Bodycontent />)}
                                    {this.state.pagetv===true && (<Bodycontenttv />)}
                                    {this.state.pagetvjw===true && (<Bodycontenttvjw />)}
                                    {this.state.pageyoutubefree===true && (<Bodycontentyoutubefree />)}
                                    {this.state.pagetodo===true && (<PageTODO />)}
                                    {this.state.pagewinampp===true && (<PageWinampp />)}
                                    {this.state.pagechat===true && (<Chat />)}
                                    {this.state.pagelogs===true && (<Logs />)}
                                    {this.state.pageusers===true && (<Users />)}
                                    <div className="footerspace" style={divStylesssp}></div>
                                        <hr className="col-12" />
                                        <h4 className="text-center text-primary">&copy; 2019 - React Sopcast</h4>
                                    <div id="footer" className="fixed-bottom">

                                    </div>
                                </div>
                            </div>
                </div>
            </div>
            </body>
            );}
            if(localStorage.getItem('authlogin')==='false'){
                return (<div></div> );
            }
    }
}